var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"icon-button",attrs:{"type":"button"}},[_c('icon',{staticClass:"icon-button__icon",attrs:{"icon":['fal', _vm.icon]}}),_c('span',{staticClass:"icon-button__label"},[_vm._v(_vm._s(_vm.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }